//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

// Constants and utilities used across the page
export const TABLE_SEARCH_BAR_WIDTH = '284px';

// Campaign reporting duration for status management
export const SAMPLING_CAMPAIGN_DURATION = 90;

// Campaign Status Definitions
export const SamplingCampaignStatusDefinitions = {
  Pending: 'Your campaign request has been approved.',
  ActionRequired: 'We need more information from you to proceed.',
  Scheduled: 'Your campaign is ready to launch.',
  Launched: 'Your campaign is live.',
  Collecting: 'Participants are posting content.',
  Completed: 'Your campaign has finished.',
};
